export default __webpack_public_path__ + "static/media/gallery_03.6eb2d8e5.jpg";